require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./en-us-region-middle-east-and-north-africa.json") })
        }
      }, "path---en-us-region-middle-east-and-north-africa");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---en-us-region-middle-east-and-north-africa!./.cache/json/en-us-region-middle-east-and-north-africa.json
// module id = 579
// module chunks = 231608221292675